import Paper from '@mui/material/Paper';
import Copyright from './Copyright';

function Footer() {
  return (
    <Paper
      component="footer"
      sx={{
        padding: '.3rem',
        borderTop: '1px solid',
        borderColor: 'divider',
      }}
    >
      <Copyright />
    </Paper>
  );
}

export default Footer;
